export default __webpack_public_path__ + "static/media/RegisterElements.5d74e889.png";